import {
  GenericAuthContext,
  InstructorAuthContext,
  AdminAuthContext,
  IdTokenWithClaims,
} from '@src/authContexts';
import SignOut from '@views/common/auth/SignOut';
import ChangePassword from '@views/common/auth/ChangePassword';
import React, { useContext } from 'react';
import InstructorLayout from './InstructorLayout';
import { NavLinkData } from '../util/navLinkData';
import { RouteLayoutProps } from './routeLayoutProps';
import StaffLayout from './admin/StaffLayout';
import { InvalidStateError } from '@util/InvalidStateError';
import AnonymousLayout from './AnonymousLayout';
import AnnouncementPage from '@views/common/announcements/AnnouncementPage';
import { Role } from '@ypp-portal/models/user/role';
import firebase from 'firebase/app';
import { AdminClaimsData } from '@ypp-portal/models/user/staffData';
import { InstructorData } from '@data/user/instructorData';

const authenticatedCommonRoutes: NavLinkData[] = [
  {
    text: 'Sign Out',
    to: '/signout',
    component: SignOut,
    inNavbar: true,
  },
  {
    to: '/changepassword',
    component: ChangePassword,
    inNavbar: false,
  },
  {
    to: '/announcements/:id',
    component: AnnouncementPage,
    inNavbar: false,
  },
];

const AuthenticatedLayout: React.FC<RouteLayoutProps> = ({ baseRoutes }) => {
  const { user, idToken, userDoc } = useContext(GenericAuthContext);

  const allowedRoutes = authenticatedCommonRoutes.concat(baseRoutes);

  if (idToken.claims.role === Role.Instructor) {
    const instructorDoc = userDoc as firebase.firestore.DocumentSnapshot<InstructorData>;
    return (
      <InstructorAuthContext.Provider value={{ user, idToken, userDoc: instructorDoc }}>
        <InstructorLayout baseRoutes={allowedRoutes}></InstructorLayout>
      </InstructorAuthContext.Provider>
    );
  }

  if (idToken.claims.role === Role.Admin) {
    const adminIdToken = idToken as IdTokenWithClaims<AdminClaimsData>;
    return (
      <AdminAuthContext.Provider value={{ user, idToken: adminIdToken, userDoc }}>
        <StaffLayout baseRoutes={allowedRoutes}></StaffLayout>
      </AdminAuthContext.Provider>
    );
  }

  if (process.env.NODE_ENV === 'production') {
    return <AnonymousLayout baseRoutes={baseRoutes}></AnonymousLayout>;
  } else {
    throw new InvalidStateError('');
  }
};

export default AuthenticatedLayout;
